export const designSystem = {
  en: {
    title: "Design System",
    subtitle: "Control the look and feel of the Solariis dashboard",
    brandColors: "Brand Colors",
    brandColorsDesc: "Three core colors that define the Solariis brand. Changes apply instantly across the dashboard.",
    reset: "Reset",
    saveChanges: "Save Changes",
    saved: "Saved!",
    black: "Black",
    blackDesc: "Primary backgrounds, navigation bars, footers, main text, dark surfaces, focus rings",
    whiteGray: "White/Gray",
    whiteGrayDesc: "Page backgrounds, cards, containers, secondary surfaces, input backgrounds",
    orangeCta: "Orange (CTA Only)",
    orangeCtaDesc: "Primary CTAs only - buttons that drive conversion. Never for focus states or decorative use.",
    livePreview: "Live Preview",
    livePreviewDesc: "See how your brand colors affect UI elements",
    lightMode: "Light Mode",
    darkMode: "Dark Mode",
    primaryCta: "Primary CTA",
    secondary: "Secondary",
    cardElement: "Card or container element",
    logoVariants: "Logo Variants",
    logoUploadDesc: "Upload and manage logo assets used across the Solariis dashboard (sidebar, login, favicon). Supported formats: SVG (recommended), PNG, JPEG, WebP. Max size: 5MB.",
    fullLogo: "Full Logo (Light)",
    fullLogoDark: "Full Logo (Dark)",
    iconOnly: "Icon Only",
    iconDark: "Icon (Dark)",
    uploadLogo: "Upload Logo",
    uploading: "Uploading...",
    removeLogo: "Remove Logo",
    remove: "Remove",
    fullLogoDesc: "Used in sidebar (expanded), login page",
    iconOnlyDesc: "Used in sidebar (collapsed), favicon",
    fullLogoDarkDesc: "For use on dark backgrounds",
    iconDarkDesc: "Icon for dark backgrounds",
    removeLogoConfirm: "Are you sure you want to remove the",
    loadingBrandColors: "Loading brand colors",
    loadingLogoVariants: "Loading logo variants",
    colorPicker: "color picker",
    hexValue: "hex value",
    sampleLightText: "Sample text on light background",
    sampleDarkText: "Sample text on dark background",
    styleTokensReference: "Style Tokens Reference",
    styleTokensReferenceDesc: "Complete reference of all semantic color tokens, status indicators, and UI colors used across the Solariis dashboard. These tokens ensure visual consistency throughout the application.",
    semanticUiColors: "Semantic UI Colors",
    semanticUiColorsDesc: "Core UI tokens derived from brand colors. Used by shadcn/ui components.",
    extendedBrandPalette: "Extended Brand Palette",
    extendedBrandPaletteDesc: "Additional brand colors for illustrations, accents, and special elements.",
    brandGradients: "Brand Gradients",
    brandGradientsDesc: "Official gradient combinations for hero sections, feature highlights, and premium UI elements.",
    colorDistributionGuidelines: "Color Distribution Guidelines",
    colorDistributionGuidelinesDesc: "The 45-42-10-3 rule: Black (45%), White/Gray (42%), Cream (10%), Orange (3% for CTAs only).",
    statusColors: "Status Colors",
    statusColorsDesc: "Used for task/project status indicators across the dashboard.",
    kanbanPhaseColors: "Kanban Phase Colors",
    kanbanPhaseColorsDesc: "Background colors for kanban board columns representing project phases.",
    moduleColors: "Module Colors",
    moduleColorsDesc: "Colors identifying different service modules in the customer dashboard.",
    borderRadius: "Border Radius",
    borderRadiusDesc: "Consistent corner rounding across all UI elements.",
    typographyScale: "Typography Scale",
    typographyScaleDesc: "Font sizes, weights, and line heights for consistent text hierarchy.",
    fontSizes: "Font Sizes",
    fontWeights: "Font Weights",
    spacingScale: "Spacing Scale",
    spacingScaleDesc: "Consistent spacing values for margins, padding, and gaps.",
    shadows: "Shadows",
    shadowsDesc: "Elevation levels for cards, modals, and interactive elements.",
    icons: "Icons",
    iconsDesc: "Lucide React icons are used throughout the dashboard. Standard sizes and stroke widths for consistency.",
    iconSizes: "Icon Sizes",
    commonActions: "Common Actions",
    animationTransitions: "Animation & Transitions",
    animationTransitionsDesc: "Standard transition durations and easing for smooth interactions.",
    transitionDurations: "Transition Durations",
    commonClasses: "Common Classes",
    usageRules: "Usage Rules (3% Orange Maximum)",
    heroSections: "Hero Sections",
    dashboardPages: "Dashboard Pages",
    cardsContainers: "Cards & Containers",
    navigationLabel: "Navigation",
    formsInputs: "Forms & Inputs",
    footerSections: "Footer Sections",
    // Upload aria-labels
    uploadLogoAria: "Upload logo file",
    removeLogoAria: "Remove logo variant",
    // Confirm dialog
    confirmRemove: "Are you sure you want to remove this logo?",
  },
  es: {
    title: "Sistema de Diseño",
    subtitle: "Controla la apariencia del panel de Solariis",
    brandColors: "Colores de Marca",
    brandColorsDesc: "Tres colores principales que definen la marca Solariis. Los cambios se aplican instantáneamente.",
    reset: "Restablecer",
    saveChanges: "Guardar Cambios",
    saved: "¡Guardado!",
    black: "Negro",
    blackDesc: "Fondos principales, barras de navegación, pies de página, texto principal, superficies oscuras",
    whiteGray: "Blanco/Gris",
    whiteGrayDesc: "Fondos de página, tarjetas, contenedores, superficies secundarias, fondos de entrada",
    orangeCta: "Naranja (Solo CTA)",
    orangeCtaDesc: "Solo CTAs principales - botones de conversión. Nunca para estados de enfoque o uso decorativo.",
    livePreview: "Vista Previa en Vivo",
    livePreviewDesc: "Ve cómo tus colores de marca afectan los elementos de la interfaz",
    lightMode: "Modo Claro",
    darkMode: "Modo Oscuro",
    primaryCta: "CTA Principal",
    secondary: "Secundario",
    cardElement: "Tarjeta o contenedor",
    logoVariants: "Variantes de Logo",
    logoUploadDesc: "Sube y gestiona activos de logo usados en el panel de Solariis (barra lateral, login, favicon). Formatos soportados: SVG (recomendado), PNG, JPEG, WebP. Tamaño máximo: 5MB.",
    fullLogo: "Logo Completo (Claro)",
    fullLogoDark: "Logo Completo (Oscuro)",
    iconOnly: "Solo Icono",
    iconDark: "Icono (Oscuro)",
    uploadLogo: "Subir Logo",
    uploading: "Subiendo...",
    removeLogo: "Eliminar Logo",
    remove: "Eliminar",
    fullLogoDesc: "Usado en barra lateral (expandida), página de login",
    iconOnlyDesc: "Usado en barra lateral (colapsada), favicon",
    fullLogoDarkDesc: "Para uso en fondos oscuros",
    iconDarkDesc: "Icono para fondos oscuros",
    removeLogoConfirm: "¿Estás seguro de que deseas eliminar el",
    loadingBrandColors: "Cargando colores de marca",
    loadingLogoVariants: "Cargando variantes de logo",
    colorPicker: "selector de color",
    hexValue: "valor hexadecimal",
    sampleLightText: "Texto de ejemplo sobre fondo claro",
    sampleDarkText: "Texto de ejemplo sobre fondo oscuro",
    styleTokensReference: "Referencia de Tokens de Estilo",
    styleTokensReferenceDesc: "Referencia completa de todos los tokens de color semánticos, indicadores de estado y colores de UI usados en el panel de Solariis. Estos tokens aseguran consistencia visual en toda la aplicación.",
    semanticUiColors: "Colores Semánticos de UI",
    semanticUiColorsDesc: "Tokens de UI principales derivados de colores de marca. Usados por componentes shadcn/ui.",
    extendedBrandPalette: "Paleta de Marca Extendida",
    extendedBrandPaletteDesc: "Colores de marca adicionales para ilustraciones, acentos y elementos especiales.",
    brandGradients: "Gradientes de Marca",
    brandGradientsDesc: "Combinaciones de gradientes oficiales para secciones hero, destacados de funciones y elementos de UI premium.",
    colorDistributionGuidelines: "Guías de Distribución de Color",
    colorDistributionGuidelinesDesc: "La regla 45-42-10-3: Negro (45%), Blanco/Gris (42%), Crema (10%), Naranja (3% solo para CTAs).",
    statusColors: "Colores de Estado",
    statusColorsDesc: "Usados para indicadores de estado de tareas/proyectos en todo el panel.",
    kanbanPhaseColors: "Colores de Fase Kanban",
    kanbanPhaseColorsDesc: "Colores de fondo para columnas del tablero kanban que representan fases del proyecto.",
    moduleColors: "Colores de Módulo",
    moduleColorsDesc: "Colores que identifican diferentes módulos de servicio en el panel del cliente.",
    borderRadius: "Radio de Borde",
    borderRadiusDesc: "Redondeo consistente de esquinas en todos los elementos de UI.",
    typographyScale: "Escala Tipográfica",
    typographyScaleDesc: "Tamaños de fuente, pesos y alturas de línea para una jerarquía de texto consistente.",
    fontSizes: "Tamaños de Fuente",
    fontWeights: "Pesos de Fuente",
    spacingScale: "Escala de Espaciado",
    spacingScaleDesc: "Valores de espaciado consistentes para márgenes, padding y gaps.",
    shadows: "Sombras",
    shadowsDesc: "Niveles de elevación para tarjetas, modales y elementos interactivos.",
    icons: "Iconos",
    iconsDesc: "Los iconos Lucide React se usan en todo el panel. Tamaños estándar y anchos de trazo para consistencia.",
    iconSizes: "Tamaños de Iconos",
    commonActions: "Acciones Comunes",
    animationTransitions: "Animación y Transiciones",
    animationTransitionsDesc: "Duraciones de transición estándar y suavizado para interacciones fluidas.",
    transitionDurations: "Duraciones de Transición",
    commonClasses: "Clases Comunes",
    usageRules: "Reglas de Uso (3% Naranja Máximo)",
    heroSections: "Secciones Hero",
    dashboardPages: "Páginas del Panel",
    cardsContainers: "Tarjetas y Contenedores",
    navigationLabel: "Navegación",
    formsInputs: "Formularios y Entradas",
    footerSections: "Secciones de Pie de Página",
    // Upload aria-labels
    uploadLogoAria: "Subir archivo de logo",
    removeLogoAria: "Eliminar variante de logo",
    // Confirm dialog
    confirmRemove: "¿Estás seguro de que deseas eliminar este logo?",
  },
};
